import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-632f17d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox-wrapper" }
const _hoisted_2 = ["checked", "value", "name", "id"]
const _hoisted_3 = ["for", "tabindex"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createElementVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1))
const _hoisted_5 = { class: "checkboxtext" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("input", {
      class: "inp-cbx",
      checked: _ctx.checked,
      value: _ctx.value,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateInput($event.target.checked))),
      name: _ctx.name || _ctx.guid,
      id: _ctx.guid,
      type: "checkbox",
      style: {"display":"none"}
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      class: _normalizeClass(["cbx same-size w-100", { 'single-line': _ctx.singleLine }]),
      for: _ctx.guid,
      tabindex: _ctx.tabIndex
    }, [
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.label), 1)
        ], true)
      ])
    ], 10, _hoisted_3)
  ]))
}